module.exports = __webpack_public_path__ + "static/media/email.c2c5ca0a.svg";